/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

import {RegistDialogComponent} from "../../../platform/auth/regist-dialog/regist-dialog.component";

import {Router} from "@angular/router";
import {AuthLevel} from "../../../../../types/aig/universe";
import {Callback, IErrorObject} from "../../../../../types/platform/universe";
import {AigiaAuthService} from "../../auth/aigia-auth.service";
import {TranslateService} from "@ngx-translate/core";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-stuff-guest-regist-dialog",
	styleUrls: ["../guests2.component.css"],
	templateUrl: "./stuff-guest-regist-dialog.component.html",
})
export class StuffGuestRegistDialogComponent extends RegistDialogComponent implements OnInit {

	public auths: any[] = [
		{name: "スタジオ", value: AuthLevel.studio},
		{name: "ユーザ", value: AuthLevel.user},
	];

	public types: any[] = [
		{name: "スタジオ", value: "studio"},
		{name: "ユーザ", value: ""},
	];

	/**
	 * @constructor
	 * @param data
	 * @param matDialogRef
	 * @param snackbar
	 * @param auth
	 * @param router
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<StuffGuestRegistDialogComponent>,
		public snackbar: MatSnackBar,
		public auth: AigiaAuthService,
		protected router: Router,
		public translate: TranslateService
	) {
		super(data, matDialogRef, snackbar, auth, router);
	}

	/**
	 * todo
	 */
	public toNickname(): void {
		const names: string[] | null = this.content.username.split("@");
		if (names) {
			if (names.length > 0) {
				this.content.nickname = names[0];
			}
		}
	}

	/**
	 * @returns none
	 */
	private async sha256(text: string): Promise<string> {
		const uint8 = new TextEncoder().encode(text)
		const digest = await crypto.subtle.digest('SHA-256', uint8)
		return Array.from(new Uint8Array(digest)).map(v => v.toString(16).padStart(2, '0')).join('')
	}

	/**
	 * @returns none
	 */
	private HashValue(S: string, length: number, callback: Callback<string>): void {
		this.sha256(S).then((hash): void => {
			callback(null, hash.slice(0, length));
		}).catch((error): void => {
			callback(error, null);
		});
	}

	/**
	 * todo
	 */
	public onAccept(): void {
		this.Progress(true);
		const category: string = "";
		const type: string = this.content.type;
		const auth: number = this.content.auth;
		const metadata: any = {nickname: this.content.nickname, id: this.content.params};

		this.auth.regist(auth, this.content.username, this.content.password, category, type, metadata, (error: IErrorObject, result: any) => {
			if (!error) {
				this.matDialogRef.close(this.data);
			} else {
				this.errorBar(error);
			}
			this.Progress(false);
		});
	}
}
